let flag = {
   en_US: require('./../assets/flag/EN.png'),
   es_US: require('./../assets/flag/ES.png'),
   ru_RU: require('./../assets/flag/RU.png'),
   ua_UA: require('./../assets/flag/UA.png'),
   zh_ZH: require('./../assets/flag/ZH.png'),
   de_DE: require('./../assets/flag/DE.png'),
   ko_KO: require('./../assets/flag/KO.png'),
   ja_JA: require('./../assets/flag/JA.png')
}

module.exports = flag;



// WEBPACK FOOTER //
// ./src/data/flag.js